import { cn } from '@/lib/utils';

export interface StatCardProps {
  title: string;
  value: string | number;
  className?: string;
}

export default function StatCard({ title, value, className }: StatCardProps) {
  return (
    <div className={cn('rounded-lg border border-border/60 bg-card p-4 sm:p-5', className)}>
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{title}</p>
      <p className="text-2xl font-semibold tabular-nums mt-1">{value}</p>
    </div>
  );
}
